// extracted by css-extract-rspack-plugin
export default {"Root":"VXv3Z","FooterButtonGroup":"yYoL6","Button":"b0Jsm"};